(function () {
  function getActiveFilterOptions() {
    const params = new URLSearchParams(window.location.search);
    const filters = {};
    params.forEach((value, key) => {
      const match = key.match(/filter\.p\.option\.(.+)/i);
      if (match) {
        const optionName = decodeURIComponent(match[1]).toLowerCase();
        if (!filters[optionName]) filters[optionName] = [];
        filters[optionName].push(decodeURIComponent(value).toLowerCase());
      }
    });
    return filters;
  }

  function hideUnavailableCards() {
    const filters = getActiveFilterOptions();
    if (Object.keys(filters).length === 0) {
      document.querySelectorAll('product-card').forEach(card => card.style.display = '');
      return;
    }

    document.querySelectorAll('product-card').forEach(card => {
      const dataEl = card.querySelector('script[type="application/json"]');
      if (!dataEl) return;

      let product;
      try { product = JSON.parse(dataEl.textContent); } catch (e) { return; }

      const variants = product.variants || [];
      const hasMatch = variants.some(variant => {
        if (!variant.available) return false;
        return Object.entries(filters).every(([optionName, filterValues]) => {
          const matchIndex = product.options.findIndex(o => o.toLowerCase().includes(optionName));
          if (matchIndex === -1) return false;
          const variantValue = variant[`option${matchIndex + 1}`];
          return variantValue && filterValues.includes(variantValue.toLowerCase());
        });
      });

      card.style.display = hasMatch ? '' : 'none';
    });
  }

  hideUnavailableCards();

  const observer = new MutationObserver(() => hideUnavailableCards());
  const grid = document.querySelector('#product-grid, .collection, [id*="product-grid"]');
  if (grid) observer.observe(grid, { childList: true, subtree: true });
})();
